module.exports = __webpack_public_path__ + "static/media/bg-hero-banner.7f3ad843.png";